export enum StudentTicketChangeType {
  MANDATE_HOLDER_DATA = 'MANDATE_HOLDER_DATA',
  ADDRESS_DATA = "ADDRESS_DATA",
  SCHOOL_DATA = "SCHOOL_DATA",
  NAME_DATA = "NAME_DATA",
  PAYMENT_DATA = "PAYMENT_DATA"
}
